import React from 'react';
import './App.scss';
import BreakLength from './breaklength.js'
import SessionLength from './sessionlength.js'
import DisplayLabel from './displayLabel.js'
import StartPause from './startPause.js'
import TimerDisplay from './timerDisplay.js'
import Reset from './reset.js'

class App extends React.Component{
    constructor(props){
        super(props);
    }
    
    render(){
        return (
            <div className="App container">
                <div className='componentWrapper'>
                    <BreakLength/>
                    <DisplayLabel/>
                    <SessionLength/>
                </div>
                <div id='bottomOfClock' className='componentWrapper'>
                    <StartPause/>
                    <TimerDisplay/>
                    <Reset/>
                </div>
            </div>
        );
    }
}


export default App;
